export default "__VITE_ASSET__c73f5ffe__"